import Image from "next/image";
import { useEffect, useState } from "react"

export const FallBackImage = ({ src, alt, ...rest }) => {
    const [imgSrc, setImgSrc] = useState(src);
    useEffect(() => { setImgSrc(src); }, [src]);

    return (
        <Image
            {...rest}
            alt={alt}
            width={100}
            height={100}
            src={imgSrc ? imgSrc : '/img/no-image.jpeg'}
            onError={() => { setImgSrc('/img/no-image.jpeg') }} />
    )
}